document.addEventListener("DOMContentLoaded", function () {

  // TRIGGER → TARGET(S)
  const sectionMap = {
    "shopify-section-template--26693471535384__rhea_kapoor_section_2_LfJajw": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_1_rQMaBT"
    ],

    "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--26693471535384__rhea_kapoor_section_2_LfJajw"
    ],

    "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9"
    ],

    "shopify-section-template--26693471535384__1765169824ba0a27bb": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn"
    ],


    "shopify-section-template--26693471535384__rhea_kapoor_section_4_6kpj9G": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_7_iLaceT"
    ],

    "shopify-section-template--26693471535384__reha_kapoor_section_7_6EUCqn": [
      "shopify-section-template--26693471535384__rhea_kapoor_section_2_LfJajw",
      "shopify-section-template--26693471535384__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9",
      "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn",
      "shopify-section-template--26693471535384__1765169824ba0a27bb",
      "shopify-section-template--26693471535384__rhea_kapoor_section_4_6kpj9G",
      "shopify-section-template--26693471535384__rhea_kapoor_section_7_iLaceT"
    ],
    "shopify-section-sections--25484700221803__footer":[
      "shopify-section-template--26693471535384__rhea_kapoor_section_2_LfJajw",
      "shopify-section-template--26693471535384__rhea_kapoor_section_3_y7Q3P4",
      "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9",
      "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn",
      "shopify-section-template--26693471535384__1765169824ba0a27bb",
      "shopify-section-template--26693471535384__rhea_kapoor_section_4_6kpj9G",
      "shopify-section-template--26693471535384__rhea_kapoor_section_7_iLaceT"
    ]
  };


  // Create observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const targets = sectionMap[entry.target.id];
        if (!targets) return;

        targets.forEach((targetId) => {
          const el = document.getElementById(targetId);
          if (!el) return;

          if (entry.intersectionRatio >= 0.5) {
            el.classList.add("myAnimation");
          } else {
            el.classList.remove("myAnimation");
          }
        });
      });
    },
    { threshold: 0.5 }
  );


  // Attach observer to all trigger sections
  Object.keys(sectionMap).forEach((id) => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9";
  const targetId  = "shopify-section-template--26693471535384__rhea_kapoor_section_4_HkeaW9";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("zoom-animation");
        } else {
          target.classList.remove("zoom-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--26693471535384__rhea_kapoor_section_4_6kpj9G";
  const targetId  = "shopify-section-template--26693471535384__rhea_kapoor_section_4_6kpj9G";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("zoom-animation");
        } else {
          target.classList.remove("zoom-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


document.addEventListener("DOMContentLoaded", function () {

  const triggerId = "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn";
  const targetId  = "shopify-section-template--26693471535384__rhea_kapoor_section_5_h7tCnn";

  const trigger = document.getElementById(triggerId);
  const target = document.getElementById(targetId);

  if (!trigger || !target) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.3) {
          target.classList.add("side-animation");
        } else {
          target.classList.remove("side-animation");
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(trigger);
});


// video sound play 

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.banner-video');
  const unmuteBtn = document.querySelector('.video-unmute-btn');
  
  if (!unmuteBtn || videos.length === 0) return;
  
  let isMuted = true;
  
  unmuteBtn.addEventListener('click', () => {
    isMuted = !isMuted;
    
    videos.forEach(video => {
      video.muted = isMuted;
    });
    
    // Icon toggle
    const mutedIcon = unmuteBtn.querySelector('.icon-muted');
    const unmutedIcon = unmuteBtn.querySelector('.icon-unmuted');
    
    if (isMuted) {
      mutedIcon.style.display = 'block';
      unmutedIcon.style.display = 'none';
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = 'block';
    }
  });
});

